// Wrapper que permitia override dinamico de cores no tema MUI. Em arquitetura
// Tailwind puro, as cores sao definidas em src/theme/tokens.css e nao sao
// customizaveis em runtime (nenhum componente novo acessa MUI theme colors).
// Este componente vira um pass-through que apenas retem children.
// A cor customizada (setColor do hook useSettings) deixa de ser usada.

export default function ThemeColorPresets({ children }) {
  return <>{children}</>;
}
